export const OUTCOME_ACCOUNT_TYPE = "הוצאה" as const;
export const OUTCOMES_PATH = "/outcomes";
export const OUTCOMES_BREADCRUMB = { ledger: "כרטסות", list: "הוצאות" } as const;
export const OUTCOMES_STRUCTURE_CRUMBS = {
  browse: "הגדרת מבנה דפדוף",
} as const;